import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Input extends Component {
  state = {
    isActiveLabel: false,
  };

  static propTypes = {
    htmlId: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
  };

  static defaultProps = {
    htmlId: 'id',
    name: 'name',
    label: '',
    required: false,
  };

  handleFocus = () => {
    this.setState({ isActiveLabel: true });
  };

  handleBlur = e => {
    if (e.target.value === '') {
      this.setState({ isActiveLabel: false });
    }
  };

  render() {
    const { htmlId, name, label, required } = this.props;

    return (
      <Root {...this.props}>
        <input
          type="text"
          id={htmlId}
          name={name}
          required={required}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        <Label htmlFor={htmlId} active={this.state.isActiveLabel ? 1 : 0}>
          {label}
        </Label>
      </Root>
    );
  }
}

const transitionDuration = 0.15;

const Root = styled.div`
  width: 100%;
  position: relative;
  input[type='text'] {
    width: 100%;
    border-bottom: 1px solid #ffffff;
    &:-webkit-autofill {
      -webkit-text-fill-color: #ffffff;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset;
      transition: background-color 5000s ease-in-out 0s;
    }
  }
`;

const Label = styled.label`
  position: absolute;
  left: 10px;
  bottom: ${props => (props.active ? '37px' : '10px')};
  font-size: ${props => (props.active ? '12px' : '14px')};
  transition: all ${transitionDuration}s ease-out;
  pointer-events: none;
`;

export default Input;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Input.js